/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceQuoteLineRequest } from './';
import {
    FixedPriceQuoteLineRequestFromJSON,
    FixedPriceQuoteLineRequestFromJSONTyped,
    FixedPriceQuoteLineRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceQuoteDetailsRequest
 */
export interface FixedPriceQuoteDetailsRequest {
    /**
     * 
     * @type {Array<FixedPriceQuoteLineRequest>}
     * @memberof FixedPriceQuoteDetailsRequest
     */
    quoteLines?: Array<FixedPriceQuoteLineRequest>;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceQuoteDetailsRequest
     */
    additionalNotes?: string;
}

/**
 * Check if a given object implements the FixedPriceQuoteDetailsRequest interface.
 */
export function instanceOfFixedPriceQuoteDetailsRequest(value: object): value is FixedPriceQuoteDetailsRequest {
    return true;
}

export function FixedPriceQuoteDetailsRequestFromJSON(json: any): FixedPriceQuoteDetailsRequest {
    return FixedPriceQuoteDetailsRequestFromJSONTyped(json, false);
}

export function FixedPriceQuoteDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteLines': json['quoteLines'] == null ? undefined : ((json['quoteLines'] as Array<any>).map(FixedPriceQuoteLineRequestFromJSON)),
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
    };
}

export function FixedPriceQuoteDetailsRequestToJSON(value?: FixedPriceQuoteDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quoteLines': value['quoteLines'] == null ? undefined : ((value['quoteLines'] as Array<any>).map((v) => FixedPriceQuoteLineRequestToJSON(v))),
        'additionalNotes': value['additionalNotes'],
    };
}

